export default function TenantHistoryActions({
  canManage,
  invoicesLoading = false,
  statementsLoading = false,
  onInvoices,
  onStatements,
  onAddBill,
  onWaiveBill,
}) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={onInvoices}
        disabled={invoicesLoading}
        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors text-sm font-medium disabled:opacity-50"
      >
        {invoicesLoading ? "Loading..." : "Invoices"}
      </button>
      <button
        type="button"
        onClick={onStatements}
        disabled={statementsLoading}
        className="bg-slate-700 text-white px-4 py-2 rounded-lg hover:bg-slate-800 transition-colors text-sm font-medium disabled:opacity-50"
      >
        {statementsLoading ? "Loading..." : "Statements"}
      </button>
      {canManage && (
        <>
          <button
            type="button"
            onClick={onAddBill}
            className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors text-sm font-medium"
          >
            Add Bill
          </button>
          <button
            type="button"
            onClick={onWaiveBill}
            className="bg-amber-600 text-white px-4 py-2 rounded-lg hover:bg-amber-700 transition-colors text-sm font-medium"
          >
            Waive Bill
          </button>
        </>
      )}
    </div>
  );
}
